module.exports = __webpack_public_path__ + "img/img.c7a1e606.png";